import { CostCenter } from 'models/costCenter';
import { Reason } from 'services/travelReasonService';

export function mapCostCenterToReason(costCenters: CostCenter[]): Reason[] {
  return costCenters.map((c) => ({ id: c.id, name: c.name, code: c.code } as Reason));
}
